import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Button from 'shared/atoms/Button';
import Chip from 'shared/atoms/Chip';
import Table, { CELL_TYPES, ORDER_TYPES } from 'shared/organisms/Table';
import theme from 'shared/themes/default';

const NameWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing.s};
`;

const GroupMembersTable = ({ onDeleteUser, groupMembers, userId }) => {
  const { t } = useTranslation();

  return (
    <Table
      ariaLabel="group members table"
      columns={[
        {
          key: 'name',
          label: t('administrateUsers.name'),
          sticky: true,
          maskValue: true,
          type: CELL_TYPES.COMPONENT,
          render: (row) => (
            <NameWrapper>
              {row.name}
              {row.isInvited && (
                <Chip
                  background={theme.palette.team}
                  label={t('administrateUsers.invitedBadge', 'Invited')}
                  small
                  theme="dark"
                  sx={{
                    border: 'none',
                    color: theme.palette.pureDark,
                  }}
                />
              )}
            </NameWrapper>
          ),
        },
        {
          key: 'email',
          label: t('administrateUsers.email'),
          maskValue: true,
        },
        {
          key: 'delete',
          disableSorting: true,
          type: CELL_TYPES.COMPONENT,
          render: (row) => (
            <Button
              ariaLabel={`${t('playlist.remove')} ${row.email}`}
              onClick={() => onDeleteUser(row)}
              small
              type="text"
            >
              {t('playlist.remove')}
            </Button>
          ),
        },
      ]}
      items={groupMembers.map((row) => ({
        ...row,
        name: `${row.name} ${
          userId === row.id ? ` (${t('administrateUsers.you')})` : ''
        }`,
      }))}
      defaultOrder={ORDER_TYPES.ASC}
      defaultOrderBy="name"
    />
  );
};

GroupMembersTable.propTypes = {
  onDeleteUser: PropTypes.func.isRequired,
  groupMembers: PropTypes.array.isRequired,
  userId: PropTypes.string,
};

export default GroupMembersTable;
